
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import InputText from '@/components/molecules/InputText.vue'
import InputFile from '@/components/molecules/InputFile.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * 生徒情報CSVファイルアップロードモーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    LabelBase,
    InputText,
    InputFile,
    ButtonSubmit,
  },
})
export default class ModalImportStudentCsv extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** ファイル選択時のイベント */
  @Prop()
  private setFile!: (files: FileList | null) => void

  /** 送信ボタンのDisabled制御 */
  @Prop()
  private submitDisabled!: (mailAddress: string, fileSelected: boolean) => boolean

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** 選択可能なファイルの拡張子 */
  private readonly FILE_EXTENSION = '.csv'

  /** メールアドレス */
  public mailAddress: string = ''

  /** ファイルの選択状態:未選択はfalse */
  private fileSelected = false

  /**
   * 送信ボタンのDisabled制御
   *   入力値の変更を検知するため、getterでラップする
   *
   * @returns メールアドレスが未入力、ファイルが未選択ならtrue
   */
  private get disabled(): boolean {
    return this.submitDisabled(this.mailAddress, this.fileSelected)
  }

  /**
   * ファイル選択のチェンジイベント発火(ラッパーメソッド)
   *   ファイルの選択状態を判定
   *   親コンポーネントにファイルを送る
   *
   * @param files ファイル情報
   */
  private changeFiles(files: FileList | null): void {
    this.checkFile(files)
    this.setFile(files)
  }

  /**
   * ファイルの選択状態を判定
   *
   * @param files ファイル情報
   */
  private checkFile(files: FileList | null): void {
    if (files?.length === 0) {
      this.fileSelected = false
      return
    }

    this.fileSelected = true
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    // メールアドレスをクリア
    this.mailAddress = ''

    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
